import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "../Sidebar";
import {
  Divider,
  Paper,
  Typography,
  LinearProgress,
  Backdrop,
  CircularProgress,
  Grid,
  TextField,
  Button,
  IconButton,
  TableBody,
  Tooltip,
  Table,
  TableContainer,
  TablePagination,
  TableCell,
  TableHead,
  TableRow,
  Radio,
  Modal,
  Switch,
  MenuItem,
  Avatar,
  ToggleButton,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import base from "../base.json";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";

const drawerWidth = 80;
export class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: "one",
      is_loader_open: false,
      is_loader_tt: false,

      /////////////////// category details //////////////

      category_name: "",
      category_img: "",
      category: [],
      category_count: 0,
      category_page: 0,
      category_rowPerPage: 10,
      is_edit_category: false,
      category_id: "",
      is_delete_category: false,
      category_select: [],

      registration_charges :0,
      subscription_charges_per_month : 0,



      ///////////// sub category ////////////

      sub_category_name: "",
      sub_category: [],
      sub_category_page: 0,
      sub_category_rowPerPage: 10,
      sub_category_count: 0,
      is_edit_sub_category: false,
      sub_category_id: "",
      is_delete_sub_category: false,
       sub_category_img : "",

      /////////////// users /////////

      user_name: "",
      user_email: "",
      user_password: "",
      user_roles: "",

      userList: [],
      user_page: 0,
      user_rowPerPage: 10,
      user_count: 0,
      is_edit_users: false,
      users_id: "",
      is_delete_users: false,

      ////////////////// payment /////////////
      discount : 0,
      registration_amount : 0,
      activation_amount : 0,
      is_payment_accept : true

    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };



  componentDidMount() {
    this.retriveSettingsDetails()  //// retrivesettings details
    this.retriveCategory(); //// retrive category details
    this.retriveCategorySelect(); /// retrive Category for select
    this.retriveSubCategoryList(); ///// retrive sub category
    this.retriveUsers();
  }

  ////////////////// category ////////////////

  saveCategory = () => {
    if (this.state.category_name !== "" && this.state.category_img !== "" && this.state.registration_charges > 0 &&   this.state.subscription_charges_per_month > 0) {
      let formData = new FormData();
      formData.append("category_name", this.state.category_name);
      formData.append("category_img", this.state.category_img);

         formData.append("subscription_charges_per_month", this.state.subscription_charges_per_month);
         formData.append("registration_charges", this.state.registration_charges);
      this.setState({ is_loader_tt: true }, () => {
        fetch(`${base.base_url}/admin/category/addCategory`, {
          method: "post",
          body: formData,
        })
          .then((res) => {
            return res.json();
          })
          .then(() => {
            this.setState({
              is_loader_tt: false,
              category_name: "",
            });
            this.sucessfull("Successfull");
            this.retriveCategory();
          });
      });
    } else {
      this.error("Fill All Fields");
    }
  };

  retriveCategorySelect = () => {
    fetch(`${base.base_url}/admin/category/retriveCategoryListForselect`, {
      headers: {
        "content-type": "application/json",
      },
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          category_select: result.data,
        });
      });
  };

  retriveCategory = () => {
    fetch(
      `${base.base_url}/admin/category/retriveCategoryList/:${this.state.category_page}/:${this.state.category_rowPerPage}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          category: result.data,
          category_count: result.size,
        });
      });
  };

  handleChangePage_Category = (event, newPage) => {
    this.setState({ category_page: newPage }, () => {
      this.retriveCategory();
    });
  };

  handleChangeRowsPerPage_Category = (event) => {
    this.setState(
      {
        category_rowPerPage: parseInt(event.target.value, 10),
        category_page: 0,
      },
      () => {
        this.retriveCategory();
      }
    );
  };

  ////////////////// sub category select option  ////////////////

  saveSubcategory = () => {
    if (
      this.state.sub_category_name !== "" &&
      this.state.category_name !== "" &&
      this.state.category_id !== "" &&  this.state.sub_category_img!==""
    ) {
      this.setState({ is_loader_tt: true }, () => {

       let formData = new FormData();
       formData.append('category_name',this.state.category_name)
       formData.append('category_id',this.state.category_id)
       formData.append('sub_category_name',this.state.sub_category_name)
       formData.append('sub_category_img',this.state.sub_category_img)


        fetch(`${base.base_url}/admin/subcategory/addSubCategory`, {
          method: "post",
          body: formData
        })
          .then((res) => {
            return res.json();
          })
          .then(() => {
            this.setState({
              is_loader_tt: false,
              category_name: "",
              category_id: "",
              sub_category_name: "",
               sub_category_img : ""
            });
            this.sucessfull("Successfull");
             this.retriveSubCategoryList();
          });
      });
    } else {
      this.error("Fill All Fields");
    }
  };





  retriveSubCategoryList = () => {
    fetch(
      `${base.base_url}/admin/subcategory/retriveSubCategoryList/:${this.state.sub_category_page}/:${this.state.sub_category_rowPerPage}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          sub_category: result.data,
          sub_category_count: result.size,
        });
      });
  };

  handleChangePage_sub_category = (event, newPage) => {
    this.setState({ sub_category_page: newPage }, () => {
      this.retriveSubCategoryList();
    });
  };

  handleChangeRowsPerPage_sub_category = (event) => {
    this.setState(
      {
        sub_category_rowPerPage: parseInt(event.target.value, 10),
        sub_category_page: 0,
      },
      () => {
        this.retriveSubCategoryList();
      }
    );
  };

  deleteUniversity = () => {};

  ////////////////// Users ////////////////

  saveUsers = () => {
    if (
      this.state.user_name !== "" &&
      this.state.user_email !== "" &&
      this.state.user_password !== "" &&
      this.state.user_roles !== ""
    ) {
      this.setState({ is_loader_tt: true }, () => {
        fetch(`${base.base_url}/admin/user/addUsers`, {
          headers: {
            "content-type": "application/json",
          },
          method: "post",
          body: JSON.stringify({
            user_name: this.state.user_name,
            user_email: this.state.user_email,
            user_password: this.state.user_password,
            user_roles: this.state.user_roles,
          }),
        })
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            this.sucessfull(res.message);
            this.retriveUsers();
            this.setState({
              user_name: "",
              user_email: "",
              user_password: "",
              user_roles: "",
              is_loader_tt: false,
            });
          });
      });
    } else {
      this.error("Fill All Fields");
    }
  };

  retriveUsers = () => {
    fetch(
      `${base.base_url}/admin/user/userListRetrive/:${this.state.user_page}/:${this.state.user_rowPerPage}`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "get",
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
          userList: result.data,
          user_count: result.size,
        });
      });
  };

  handleChangePage_Users = (event, newPage) => {
    this.setState({ user_page: newPage }, () => {
      this.retriveUsers();
    });
  };

  handleChangeRowsPerPage_Users = (event) => {
    this.setState(
      {
        user_rowPerPage: parseInt(event.target.value, 10),
        user_page: 0,
      },
      () => {
        this.retriveUsers();
      }
    );
  };

  ////////////////// Institute Profile //////////////// ////////////////////////////////////////


  retriveInstitute = () => {};

  deleteInstitute = () => {};

  ////////////// alert

  sucessfull = (d) => {
    toast.success(d, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      //transition: Bounce,
    });
  };

  error = (d) => {
    toast.error(d, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      //transition: Bounce,
    });
  };


/////////// update admin settings //////

updateAdminSettings=()=>{

  if(this.state.discount >= 0 && this.state.registration_amount >= 0 && this.state.activation_amount >= 0 ){

   fetch(
      `${base.base_url}/admin/settings/updateSettingDetails`,
      {
        headers: {
          "content-type": "application/json",
        },
        method: "put",
        body:JSON.stringify({
      discount : this.state.discount,
      registration_amount : this.state.registration_amount,
      activation_amount : this.state.activation_amount,
      is_payment_accept : this.state.is_payment_accept
        })
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        alert("Settings details updated");
        this.retriveSettingsDetails();
      });

    }else{
      alert("fill all fileds")
    }

}



retriveSettingsDetails=()=>{
 fetch(`${base.base_url}/admin/settings/retriveSettingDetails`, {
      headers: {
        "content-type": "application/json",
      },
      method: "get",
    })
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        this.setState({
      discount : result.data.discount,
      registration_amount : result.data.registration_amount,
      activation_amount : result.data.activation_amount,
      is_payment_accept : result.data.is_payment_accept
        });
      });
}




  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            {
              /// header data
            }
            <Box
              sx={{
                height: 47,
                width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
              }}
            >
              <Tabs
                value={this.state.tab}
                onChange={this.handleChange}
                aria-label="wrapped label tabs example"
              >
                <Tab
                  value="one"
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "500",
                    fontSize: 12,
                  }}
                  label="Category"
                  onClick={() => this.setState({ tab: "one" })}
                  wrapped
                />

                <Tab
                  value="two"
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "500",
                    fontSize: 12,
                  }}
                  label="Sub Category"
                  onClick={() => this.setState({ tab: "two" })}
                  wrapped
                />

                <Tab
                  value="four"
                  onClick={() => this.setState({ tab: "four" })}
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "500",
                    fontSize: 12,
                  }}
                  label="Users"
                  wrapped
                />
                    <Tab
                  value="five"
                  onClick={() => this.setState({ tab: "five" })}
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: "500",
                    fontSize: 12,
                  }}
                  label="PAYMENT SETTINGS"
                  wrapped
                />
              </Tabs>
            </Box>

            {
              //////body segment and division
            }

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 2 },
                pr: { xs: 1, sm: 3 },
              }}
            >
              <Box sx={{ display: this.state.tab == "one" ? "block" : "none" }}>
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
                    <Box>
                      <Paper
                        variant="outlined"
                        elevation={1}
                        style={{ minHeight: 150, width: "100%", color: "#fff" }}
                      >
                        <Box sx={{ padding: 3 }}>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              color: "#1b7bce",
                              fontSize: 15,
                              marginTop: 3,
                              textTransform: "uppercase",
                              marginBottom: 8,
                              marginLeft: 1,
                            }}
                          >
                            Category
                          </Typography>

                          <Box sx={{ mt: 0, padding: 0 }}>
                            <Paper
                              variant="outlined"
                              sx={{ minHeight: 250, width: "100%" }}
                            >
                              <TableContainer
                                component={Box}
                                sx={{ backgroundColor: "#f4f4f6" }}
                              >
                                <Table
                                  sx={{ minWidth: 620 }}
                                  size="small"
                                  aria-label="a dense table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Sr No
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        category Img
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        category Name
                                      </TableCell>

                                              <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Registration charges
                                      </TableCell>

                                              <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        renewal Amount/month
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.category.map((row, index) => (
                                      <TableRow
                                        key={row._id}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                          backgroundColor:
                                            index % 2 ? "#f9f9f9" : "#fff",
                                        }}
                                      >
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          sx={{ color: "#42526e" }}
                                        >
                                          <Box
                                            sx={{
                                              height: 20,
                                              minWidth: 60,
                                              display: "flex",
                                              justifyContent: "left",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                paddingLeft: 1,
                                                paddingRight: 1,
                                              }}
                                            >
                                              {index + 1}
                                            </Typography>
                                          </Box>
                                        </TableCell>

                                        <TableCell
                                          align="right"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              width: "100%",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Avatar  
                                              alt="Remy Sharp"
                                              src={
                                                base.base_url +
                                                "/" +
                                                row.category_img
                                              }
                                              sx={{ width: 24, height: 24 }}
                                            />
                                          </Box>
                                        </TableCell>

                                        <TableCell
                                          align="center"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                          }}
                                        >
                                          {row.category_name}
                                        </TableCell>


  


                                         

                                          <TableCell
                                          align="center"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                          }}
                                        >
                                          {row.registration_charges}
                                        </TableCell>

                                          <TableCell
                                          align="center"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                          }}
                                        >
                                          {row.subscription_charges_per_month}
                                        </TableCell>







                                        <TableCell align="right">
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: "row",
                                              justifyContent: "right",
                                            }}
                                          >
                                            <Tooltip title="EDIT">
                                              <IconButton
                                                size="small"
                                                onClick={() =>
                                                  this.setState({
                                                    is_edit_category: true,
                                                    category_id: row._id,
                                                          subscription_charges_per_month:row.subscription_charges_per_month,
                                                           registration_charges:row.registration_charges,

                                                    category_name:
                                                      row.category_name,
                                                    category_img:
                                                      row.category_img,
                                                  })
                                                }
                                              >
                                                <EditIcon
                                                  sx={{
                                                    color: "#00cfe8",
                                                    height: 17,
                                                    width: 17,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>

                                            <Tooltip title="DELETE">
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  this.setState({
                                                    is_delete_category: true,
                                                    category_id: row._id,
                                                  });
                                                }}
                                              >
                                                <DeleteOutlinedIcon
                                                  sx={{
                                                    color: "red",
                                                    height: 17,
                                                    width: 17,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Divider />
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.state.category_count}
                                rowsPerPage={this.state.category_rowPerPage}
                                page={this.state.category_page}
                                onPageChange={this.handleChangePage_Category}
                                onRowsPerPageChange={
                                  this.handleChangeRowsPerPage_Category
                                }
                              />
                            </Paper>
                          </Box>
                        </Box>
                      </Paper>
                    </Box>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                    <Paper
                      variant="outlined"
                      sx={{ minHeight: 200, width: "100%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 15,
                          fontWeight: "600",
                          p: 2,
                          textTransform: "uppercase",
                          pl: 4,
                        }}
                      >
                        Add Category
                      </Typography>

                      <Box sx={{ pl: 4, pr: 4 }}>
                        <Grid container spacing={2}>
                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Category Name
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Example : Moter Vehical"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="category_name"
                              onChange={this.handleChange}
                            />
                          </Grid>

                            



                             <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Registration Amount
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              value={this.state.registration_charges}
                              placeholder="Registration charges"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="registration_charges"
                              onChange={this.handleChange}
                            />
                          </Grid>


                           <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Subscription price/month
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder=""
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="subscription_charges_per_month"
                              value={this.state.subscription_charges_per_month}
                              onChange={this.handleChange}
                            />
                          </Grid>


                          {
                            // category_img
                          }

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Category Img
                            </Typography>

                            <Box
                              sx={{
                                height: 40,
                                width: "100%",
                                backgroundColor: "#eff0f0",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: 1,
                              }}
                            >
                              <input
                                type="file"
                                name="category_img"
                                onChange={this.handleChangee}
                                style={{ marginLeft: 6 }}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                        <Box
                          sx={{
                            mt: 2,
                            mb: 2,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Button
                            size="small"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30 }}
                            onClick={this.saveCategory}
                          >
                            Save Category
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30, ml: 2 }}
                            onClick={() =>
                              this.setState({
                                category_name: "",
                                category_id: "",
                              })
                            }
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ display: this.state.tab == "two" ? "block" : "none" }}>
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
                    <Box>
                      <Paper
                        variant="outlined"
                        elevation={1}
                        style={{ minHeight: 150, width: "100%", color: "#fff" }}
                      >
                        <Box sx={{ padding: 3 }}>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              color: "#1b7bce",
                              fontSize: 15,
                              marginTop: 3,
                              textTransform: "uppercase",
                              marginBottom: 8,
                              marginLeft: 1,
                            }}
                          >
                            Sub Category
                          </Typography>

                          <Box sx={{ mt: 0, padding: 0 }}>
                            <Paper
                              variant="outlined"
                              sx={{ minHeight: 250, width: "100%" }}
                            >
                              <TableContainer
                                component={Box}
                                sx={{ backgroundColor: "#f4f4f6" }}
                              >
                                <Table
                                  sx={{ minWidth: 620 }}
                                  size="small"
                                  aria-label="a dense table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Sr. No
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Category
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Sub Category
                                      </TableCell>

                                           <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Sub Category Img
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.sub_category.map(
                                      (row, index) => (
                                        <TableRow
                                          key={row.lead_id}
                                          sx={{
                                            "&:last-child td, &:last-child th":
                                              {
                                                border: 0,
                                              },
                                            backgroundColor:
                                              index % 2 ? "#f9f9f9" : "#fff",
                                          }}
                                        >
                                          <TableCell
                                            component="th"
                                            scope="row"
                                            sx={{ color: "#42526e" }}
                                          >
                                            <Box
                                              sx={{
                                                height: 20,
                                                minWidth: 60,
                                                display: "flex",
                                                justifyContent: "left",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: 12,
                                                  fontWeight: 600,
                                                  paddingLeft: 1,
                                                  paddingRight: 1,
                                                }}
                                              >
                                                {index + 1}
                                              </Typography>
                                            </Box>
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{
                                              color: "#42526e",
                                              fontSize: 12,
                                              minWidth: 100,
                                            }}
                                          >
                                            {row.category_name}
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{
                                              color: "#42526e",
                                              fontSize: 12,
                                              minWidth: 100,
                                            }}
                                          >
                                            {row.sub_category_name}
                                          </TableCell>

                                               <TableCell
                                            align="center"
                                            sx={{
                                              color: "#42526e",
                                              fontSize: 12,
                                              minWidth: 100,
                                            }}
                                          >
                                            <Avatar
                                              alt="Remy Sharp"
                                              src={
                                                base.base_url +
                                                "/" +
                                                row.sub_category_img
                                              }
                                              sx={{ width: 24, height: 24 }}
                                            />
                                            
                                          </TableCell>

                                          <TableCell align="right">
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "right",
                                              }}
                                            >
                                              <Tooltip title="EDIT">
                                                <IconButton
                                                  size="small"
                                                  onClick={() => {
                                                    this.setState({
                                                      is_edit_sub_category: true,
                                                      sub_category_id: row._id,
                                                      sub_category_name:
                                                        row.sub_category_name,
                                                        sub_category_img:row.sub_category_img
                                                    });
                                                  }}
                                                >
                                                  <EditIcon
                                                    sx={{
                                                      color: "#00cfe8",
                                                      height: 17,
                                                      width: 17,
                                                    }}
                                                  />
                                                </IconButton>
                                              </Tooltip>

                                              <Tooltip title="DELETE">
                                                <IconButton
                                                  size="small"
                                                  onClick={() =>
                                                    this.setState({
                                                      is_delete_sub_category: true,
                                                      sub_category_id: row._id,
                                                    })
                                                  }
                                                >
                                                  <DeleteOutlinedIcon
                                                    sx={{
                                                      color: "red",
                                                      height: 17,
                                                      width: 17,
                                                    }}
                                                  />
                                                </IconButton>
                                              </Tooltip>
                                            </Box>
                                          </TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Divider />
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.state.sub_category_count}
                                rowsPerPage={this.state.sub_category_rowPerPage}
                                page={this.state.sub_category_page}
                                onPageChange={
                                  this.handleChangePage_sub_category
                                }
                                onRowsPerPageChange={
                                  this.handleChangeRowsPerPage_sub_category
                                }
                              />
                            </Paper>
                          </Box>
                        </Box>
                      </Paper>
                    </Box>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                    <Paper
                      variant="outlined"
                      sx={{ minHeight: 100, width: "100%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 15,
                          fontWeight: "600",
                          p: 2,
                          textTransform: "uppercase",
                          pl: 4,
                        }}
                      >
                        Add Sub Category
                      </Typography>

                      <Box sx={{ pl: 4, pr: 4 }}>
                        <Grid container spacing={2}>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Category
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Category"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              select
                              name="category_name"
                              //value={this.state.medium_name}
                              onChange={this.handleChange}
                            >
                              {this.state.category_select.map((option) => (
                                <MenuItem
                                  key={option._id}
                                  sx={{ fontSize: 11 }}
                                  value={option.category_name}
                                  onClick={() =>
                                    this.setState({
                                      category_name: option.category_name,
                                      category_id: option._id,
                                    })
                                  }
                                >
                                  {option.category_name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Sub Category
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Sub Category"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="sub_category_name"
                              value={this.state.sub_category_name}
                              onChange={this.handleChange}
                            />
                          </Grid>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                             Sub Category Img
                            </Typography>

                            <Box
                              sx={{
                                height: 40,
                                width: "100%",
                                backgroundColor: "#eff0f0",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: 1,
                              }}
                            >
                              <input
                                type="file"
                                name='sub_category_img'
                                onChange={this.handleChangee}
                                style={{ marginLeft: 6 }}
                              />
                            </Box>
                          </Grid>

                        </Grid>
                        <Box
                          sx={{
                            mt: 2,
                            mb: 2,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Button
                            size="small"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30 }}
                            onClick={this.saveSubcategory}
                          >
                            Save Sub Category
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30, ml: 2 }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{ display: this.state.tab == "four" ? "block" : "none" }}
              >
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 12, md: 8 }}>
                    <Box>
                      <Paper
                        variant="outlined"
                        elevation={1}
                        style={{ minHeight: 150, width: "100%", color: "#fff" }}
                      >
                        <Box sx={{ padding: 3 }}>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              color: "#1b7bce",
                              fontSize: 15,
                              marginTop: 3,
                              textTransform: "uppercase",
                              marginBottom: 8,
                              marginLeft: 1,
                            }}
                          >
                            CRM Users
                          </Typography>

                          <Box sx={{ mt: 0, padding: 0 }}>
                            <Paper
                              variant="outlined"
                              sx={{ minHeight: 250, width: "100%" }}
                            >
                              <TableContainer
                                component={Box}
                                sx={{ backgroundColor: "#f4f4f6" }}
                              >
                                <Table
                                  sx={{ minWidth: 620 }}
                                  size="small"
                                  aria-label="a dense table"
                                >
                                  <TableHead>
                                    <TableRow>
                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Name
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Email
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Roles
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: 14,
                                          fontWeight: "600",
                                          color: "#008ffb",
                                        }}
                                      >
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {this.state.userList.map((row, index) => (
                                      <TableRow
                                        key={row._id}
                                        sx={{
                                          "&:last-child td, &:last-child th": {
                                            border: 0,
                                          },
                                          backgroundColor:
                                            index % 2 ? "#f9f9f9" : "#fff",
                                        }}
                                      >
                                        <TableCell
                                          component="th"
                                          scope="row"
                                          sx={{ color: "#42526e" }}
                                        >
                                          <Box
                                            sx={{
                                              height: 20,
                                              minWidth: 60,
                                              display: "flex",
                                              justifyContent: "left",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                paddingLeft: 1,
                                                paddingRight: 1,
                                              }}
                                            >
                                              {row.user_name}
                                            </Typography>
                                          </Box>
                                        </TableCell>

                                        <TableCell
                                          align="center"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                            minWidth: 100,
                                          }}
                                        >
                                          {row.user_email}
                                        </TableCell>

                                        <TableCell
                                          align="center"
                                          sx={{
                                            color: "#42526e",
                                            fontSize: 12,
                                            minWidth: 100,
                                          }}
                                        >
                                          {row.user_roles}
                                        </TableCell>

                                        <TableCell align="right">
                                          <Box
                                            sx={{
                                              display: "flex",
                                              flexDirection: "row",
                                              justifyContent: "right",
                                            }}
                                          >
                                            <Tooltip title="EDIT">
                                              <IconButton
                                                size="small"
                                                onClick={() =>
                                                  this.setState({
                                                    is_edit_users: true,
                                                    user_name: row.user_name,
                                                    user_email: row.user_email,
                                                    user_password:
                                                      row.user_password,
                                                    user_roles: row.user_roles,
                                                    users_id: row._id,
                                                  })
                                                }
                                              >
                                                <EditIcon
                                                  sx={{
                                                    color: "#00cfe8",
                                                    height: 17,
                                                    width: 17,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>

                                            <Tooltip title="DELETE">
                                              <IconButton
                                                size="small"
                                                onClick={() => {
                                                  this.setState({
                                                    is_delete_users: true,
                                                    users_id: row._id,
                                                  });
                                                }}
                                              >
                                                <DeleteOutlinedIcon
                                                  sx={{
                                                    color: "red",
                                                    height: 17,
                                                    width: 17,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <Divider />
                              <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.state.user_count}
                                rowsPerPage={this.state.user_rowPerPage}
                                page={this.state.user_page}
                                onPageChange={this.handleChangePage_Users}
                                onRowsPerPageChange={
                                  this.handleChangeRowsPerPage_Users
                                }
                              />
                            </Paper>
                          </Box>
                        </Box>
                      </Paper>
                    </Box>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                    <Paper
                      variant="outlined"
                      sx={{ minHeight: 100, width: "100%" }}
                    >
                      <Typography
                        sx={{
                          fontSize: 15,
                          fontWeight: "600",
                          p: 2,
                          textTransform: "uppercase",
                          pl: 4,
                        }}
                      >
                        Add Users
                      </Typography>

                      <Box sx={{ pl: 4, pr: 4 }}>
                        <Grid container spacing={2}>
                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Users Name
                            </Typography>

                            <TextField
                              size="small"
                              type="text"
                              placeholder="Users Name"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="user_name"
                              value={this.state.user_name}
                              onChange={this.handleChange}
                            />
                          </Grid>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Email
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Email"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="user_email"
                              value={this.state.user_email}
                              onChange={this.handleChange}
                            />
                          </Grid>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Password
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder="Password"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="user_password"
                              value={this.state.user_password}
                              onChange={this.handleChange}
                            />
                          </Grid>

                          <Grid item size={{ xs: 12 }}>
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Roles
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              select
                              placeholder="Roles"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              //name="user_roles"
                              onChange={this.handleChange}
                            >
                              {["Admin"].map((option) => (
                                <MenuItem
                                  key={option}
                                  value={option}
                                  sx={{ fontSize: 11 }}
                                  onClick={() =>
                                    this.setState({ user_roles: option })
                                  }
                                >
                                  {option}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        </Grid>
                        <Box
                          sx={{
                            mt: 2,
                            mb: 2,
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <Button
                            size="small"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30 }}
                            onClick={this.saveUsers}
                          >
                            Save Users
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            sx={{ textTransform: "none", height: 30, ml: 2 }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>




              <Box
                sx={{ display: this.state.tab == "five" ? "block" : "none" }}
              >
               <Paper sx={{minHeight:200,width:'100%',display:'flex',flexDirection:'column'}}>

                 <Typography sx={{fontSize:12,fontWeight:'bold',pt:5,pl:5}}>IS PAYMENT IS ACCEPTABLE</Typography>
                 <Switch onClick={()=>{this.state.is_payment_accept?this.setState({is_payment_accept:false}):this.setState({is_payment_accept:true})}} checked={this.state.is_payment_accept} sx={{ml:5}}/>
                    
                    <Typography sx={{fontSize:12,fontWeight:'bold',pt:1,pl:5}}>Registration Amount</Typography>
                   <TextField value={this.state.registration_amount} name="registration_amount" onChange={this.handleChange} size="small" sx={{width:250,fontSize:12,ml:5}} placeholder="Registration Amount"/>
                   <Typography sx={{fontSize:12,fontWeight:'bold',pt:1,pl:5}}>Activation Amount/month</Typography>
                   <TextField  value={this.state.activation_amount} name="activation_amount"  onChange={this.handleChange} size="small" sx={{width:250,fontSize:12,ml:5}} placeholder="Activation Amount Per Month"/>
                    <Typography sx={{fontSize:12,fontWeight:'bold',pt:1,pl:5}}>Discount Amount(%)</Typography>
                   <TextField  value={this.state.discount} name="discount"  size="small" onChange={this.handleChange} sx={{width:250,fontSize:12,ml:5}} placeholder="Discount"/>
                   <Button variant="contained" size="small" sx={{mt:2,width:150,ml:5}} onClick={this.updateAdminSettings}>Save details</Button>

                   <br/>
                   <br/>
               </Paper>
              </Box>





            </Box>
          </Box>
        </Box>

        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            backgroundColor: "transparent",
            zIndex: theme.zIndex.drawer + 1,
          })}
          open={this.state.is_loader_open}
          onClick={this.handleClose}
        >
          <CircularProgress sx={{ color: "#008ffb" }} />
        </Backdrop>

        {
          //////// category edit details here
        }

        <Box>
          <Modal
            open={this.state.is_edit_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "30%", lg: "30%" },
                  height: "50vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_edit_category: false,
                        category_id: "",
                        category_name: "",
                      })
                    }
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                  Update Category Details:
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >
                      Category Name
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="For example 2025-2026"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      name="category_name"
                      value={this.state.category_name}
                      onChange={this.handleChange}
                    />



                    
                           
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Registration Amount
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              value={this.state.registration_charges}
                              placeholder="Registration charges"
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="registration_charges"
                              onChange={this.handleChange}
                            />
                      


                        
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "#515151",
                                fontWeight: "bold",
                                p: 0.5,
                              }}
                            >
                              Subscription price/month
                            </Typography>
                            <TextField
                              size="small"
                              type="text"
                              placeholder=""
                              fullWidth
                              InputProps={{
                                style: { fontSize: 11, fontWeight: "500" },
                              }}
                              name="subscription_charges_per_month"
                              value={this.state.subscription_charges_per_month}
                              onChange={this.handleChange}
                            />
                       

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                      }}
                    >
                      Category Img
                    </Typography>

                    <Box
                      sx={{
                        height: 40,
                        width: "100%",
                        backgroundColor: "#eff0f0",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 1,
                      }}
                    >
                      <input
                        type="file"
                        name="category_img"
                        onChange={this.handleChangee}
                        style={{ marginLeft: 6 }}
                      />
                    </Box>

                    <br />

                    <Button
                      onClick={() => {
                        if (
                          this.state.category_name !== "" &&
                          this.state.category_img !== "" &&  this.state.registration_charges > 0 &&   this.state.subscription_charges_per_month > 0
                        ) {
                          let formData = new FormData();
                          formData.append(
                            "category_name",
                            this.state.category_name
                          );
                           

                             
                                   formData.append(
                            "registration_charges",
                            this.state.registration_charges
                          );

                                   formData.append(
                            "subscription_charges_per_month",
                            this.state.subscription_charges_per_month
                          );




                          formData.append(
                            "category_img",
                            this.state.category_img
                          );

                          formData.append("_id", this.state.category_id);

                          fetch(
                            `${base.base_url}/admin/category/updateCategory`,
                            {
                              method: "put",
                              body: formData,
                            }
                          )
                            .then((res) => {
                              return res.json();
                            })
                            .then(() => {
                              this.sucessfull("category details updated");
                              this.category();
                              this.setState({
                                registration_charges:0,
                                 subscription_charges_per_month:0,
                                category_name: "",
                                category_id: "",
                                category_img: "",
                                is_edit_category: false,
                              });
                            });
                        } else {
                          this.sucessfull("Fill all fields");
                        }
                      }}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 3,
                        textTransform: "none",
                      }}
                    >
                      Edit Category
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        <Box>
          <Modal
            open={this.state.is_delete_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() =>
                        this.setState({ is_delete_category: false })
                      }
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(
                          `${base.base_url}/admin/category/deleteCategory`,
                          {
                            headers: {
                              "content-type": "application/json",
                            },

                            method: "delete",
                            body: JSON.stringify({
                              _id: this.state.category_id,
                            }),
                          }
                        )
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              category_id: "",
                              is_delete_category: false,
                            });
                            this.retriveCategory();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        {
          //////// sub category edit details here
        }

        <Box>
          <Modal
            open={this.state.is_edit_sub_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "30%", lg: "30%" },
                  height: "50vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_edit_sub_category: false,
                        category_id: "",
                        category_name: "",
                        sub_category_name: "",
                      })
                    }
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                  Update Sub Category Details:
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >
                      Sub Category Name
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="For example 2025-2026"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      name="sub_category_name"
                      value={this.state.sub_category_name}
                      onChange={this.handleChange}
                    />

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >  
                      Category Name
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="Category"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      select
                      name="category_name"
                      value={this.state.category_name}
                      onChange={this.handleChange}
                    >
                      {this.state.category_select.map((option) => (
                        <MenuItem
                          key={option.category_name}
                          sx={{ fontSize: 11 }}
                          value={option.category_name}
                          onClick={() =>
                            this.setState({
                              category_name: option.category_name,
                              category_id: option._id,
                            })
                          }
                        >
                          {option.category_name}
                        </MenuItem>
                      ))}
                    </TextField>
                    <br />


                         <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                      }}
                    >
                     Sub Category Img
                    </Typography>

                    <Box
                      sx={{
                        height: 40,
                        width: "100%",
                        backgroundColor: "#eff0f0",
                        display: "flex",
                        alignItems: "center",
                        borderRadius: 1,
                      }}
                    >
                      <input
                        type="file"
                        name="sub_category_img"
                        onChange={this.handleChangee}
                        style={{ marginLeft: 6 }}
                      />
                    </Box>



                    <Button
                      onClick={() => {
                        if (
                          this.state.category_name !== "" &&
                          this.state.category_id !== "" &&
                          this.state.sub_category_name !== "" && this.state.sub_category_img!==""
                        ) {

                          let formData = new FormData()
                          formData.append('category_name',this.state.category_name);
                            formData.append('sub_category_name',this.state.sub_category_name);
                              formData.append('_id',this.state.sub_category_id);
                               formData.append('sub_category_img',this.state.sub_category_img);

                          fetch(
                            `${base.base_url}/admin/subcategory/updateSubCategory`,
                            {
                              
                              method: "put",
                              body: formData
                            }
                          )
                            .then((res) => {
                              return res.json();
                            })
                            .then(() => {
                              this.sucessfull("SubCategory details updated");
                              this.retriveSubCategoryList();
                              this.setState({
                                is_edit_sub_category: false,
                                category_id: "",
                                category_name: "",
                                sub_category_name: "",
                              });
                            });
                        } else {
                          this.error("Fill all fields");
                        }
                      }}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 3,
                        textTransform: "none",
                      }}
                    >
                      Edit Sub Category
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        <Box>
          <Modal
            open={this.state.is_delete_sub_category}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() =>
                        this.setState({ is_delete_sub_category: false })
                      }
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(
                          `${base.base_url}/admin/subcategory/deleteSubCategory`,
                          {
                            headers: {
                              "content-type": "application/json",
                            },
                            method: "delete",
                            body: JSON.stringify({
                              _id: this.state.sub_category_id,
                            }),
                          }
                        )
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              sub_category_id: "",
                              is_delete_sub_category: false,
                            });
                            this.retriveSubCategoryList();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        {
          //////// user edit details here
        }

        <Box>
          <Modal
            open={this.state.is_edit_users}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "30%", lg: "30%" },
                  height: "90vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <Paper
                    onClick={() =>
                      this.setState({
                        is_edit_users: false,
                        user_name: "",
                        user_password: "",
                        user_email: "",
                        user_roles: "",
                      })
                    }
                  >
                    <CloseIcon
                      sx={{ height: 20, width: 20, color: "#2486bb" }}
                    />
                  </Paper>
                </Box>

                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",

                    paddingLeft: { xs: 2, sm: 4 },
                    mb: 2,
                  }}
                >
                  Update Users Details:
                </Typography>
                <Divider />
                <Box
                  sx={{
                    overflowY: "scroll",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      borderRadius: 10,
                    },
                  }}
                >
                  <Box
                    sx={{
                      paddingLeft: { xs: 2, sm: 4 },
                      paddingRight: { xs: 2, sm: 4 },
                      height: "76vh",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                      }}
                    >
                      Users Name
                    </Typography>

                    <TextField
                      size="small"
                      type="text"
                      placeholder="Users Name"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      name="user_name"
                      value={this.state.user_name}
                      onChange={this.handleChange}
                    />

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >
                      Email
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="Email"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      name="user_email"
                      value={this.state.user_email}
                      onChange={this.handleChange}
                    />

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >
                      Password
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      placeholder="Password"
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      name="user_password"
                      value={this.state.user_password}
                      onChange={this.handleChange}
                    />

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#515151",
                        fontWeight: "bold",
                        p: 0.5,
                        mt: 2,
                      }}
                    >
                      Roles
                    </Typography>
                    <TextField
                      size="small"
                      type="text"
                      select
                      placeholder="Roles"
                      defaultValue={this.state.user_roles}
                      fullWidth
                      InputProps={{
                        style: { fontSize: 11, fontWeight: "500" },
                      }}
                      //name="user_roles"
                      onChange={this.handleChange}
                    >
                      {["Admin"].map((option) => (
                        <MenuItem
                          key={option}
                          value={option}
                          sx={{ fontSize: 11 }}
                          onClick={() => this.setState({ user_roles: option })}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>

                    <br />

                    <Button
                      onClick={() => {
                        if (
                          this.state.user_name !== "" &&
                          this.state.user_email !== "" &&
                          this.state.user_password !== "" &&
                          this.state.user_roles !== ""
                        ) {
                          fetch(`${base.base_url}/admin/user/updateUsers`, {
                            headers: {
                              "content-type": "application/json",
                            },
                            method: "put",
                            body: JSON.stringify({
                              user_name: this.state.user_name,
                              user_email: this.state.user_email,
                              user_password: this.state.user_password,
                              user_roles: this.state.user_roles,
                              _id: this.state.users_id,
                            }),
                          })
                            .then((res) => {
                              return res.json();
                            })
                            .then((res) => {
                              this.sucessfull(res.message);
                              this.retriveUniversity();
                              this.setState({
                                user_name: "",
                                user_email: "",
                                user_password: "",
                                user_roles: "",
                                is_edit_users: false,
                              });
                            });
                        } else {
                          this.error("Fill all fields");
                        }
                      }}
                      variant="contained"
                      disableElevation
                      size="small"
                      sx={{
                        backgroundColor: "#2486bb",
                        mt: 3,
                        textTransform: "none",
                      }}
                    >
                      Edit Users
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        <Box>
          <Modal
            open={this.state.is_delete_users}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() => this.setState({ is_delete_medium: false })}
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(`${base.base_url}/admin/user/deleteUsers`, {
                          headers: {
                            "content-type": "application/json",
                          },
                          method: "delete",
                          body: JSON.stringify({
                            _id: this.state.users_id,
                          }),
                        })
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              users_id: "",
                              is_delete_users: false,
                            });
                            this.retriveUsers();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>

        <Backdrop
          sx={(theme) => ({
            color: "#fff",
            backgroundColor: "transparent",
            zIndex: theme.zIndex.drawer + 1,
          })}
          open={this.state.is_loader_tt}
          onClick={this.handleClose}
        >
          <CircularProgress sx={{ color: "#008ffb" }} />
        </Backdrop>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          //transition={Bounce}
        />
      </Box>
    );
  }
}

export default Settings;
